export const roundToTwo = (num: number) =>
  Number(Math.round(Number(num + "e+2")) + "e-2");
